import {
  Component, Vue, ProvideReactive,
} from 'vue-property-decorator';
import HttpService from '../../../services/httpService';
import { Inject } from 'vue-di-container';
import UserService from '../../../services/userService';
import WithRender from './persona-container.html';
import { LoginTypePersonasEnum } from '@/modules/shared/enums/login-type-personas';

@WithRender
@Component
export default class PersonaContainer extends Vue {
  @Inject(HttpService)
  public httpService!: HttpService;

  @Inject(UserService)
  public userService!: UserService;

  @ProvideReactive()
  public persona: LoginTypePersonasEnum = LoginTypePersonasEnum.ANONYMOUS;

  async created() {
    const res = await this.userService.getUser();
    this.persona = res.loginType;
  }
}
